import { createAsyncThunk } from "@reduxjs/toolkit";
import { calculateRemainingTime } from "../../utils/auth-helper";

let logoutTimer;
export const userSignUp = createAsyncThunk(
  "auth/userSignUp",
  async (userInfo, { rejectWithValue }) => {
    const { firstname, lastname, email, password } = userInfo;

    const url = process.env.REACT_APP_DB_AUTH_URL + "/register";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ firstName:firstname, lastName:lastname, email, password }),
    });
    if (!response.ok) {
      return rejectWithValue("Couldn't register user");
    }
    const data = await response.json();
    const { token, expiresAt, firstName, lastName } = data;

    localStorage.setItem("authTokenPIXELBAY", token);
    localStorage.setItem("expiresAtPIXELBAY", expiresAt);
    localStorage.setItem("firstNamePIXELBAY", firstName);
    localStorage.setItem("lastNamePIXELBAY", lastName);

    const remainingTime = calculateRemainingTime(expiresAt);
    logoutTimer = setTimeout(userLogOut, remainingTime);
    
    return { token, expiresAt, firstName, lastName };
  }
);

export const userLogIn = createAsyncThunk(
  "auth/userLogIn",
  async (userInfo, { rejectWithValue }) => {
    const { email, password } = userInfo;
    const url = process.env.REACT_APP_DB_AUTH_URL + "/login";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    if (!response.ok) {
      return rejectWithValue("Invalid credentials!");
    }
    const data = await response.json();
    const { token, expiresAt, firstName, lastName } = data;
    localStorage.setItem("authTokenPIXELBAY", token);
    localStorage.setItem("expiresAtPIXELBAY", expiresAt);
    localStorage.setItem("firstNamePIXELBAY", firstName);
    localStorage.setItem("lastNamePIXELBAY", lastName);

    const remainingTime = calculateRemainingTime(expiresAt);
    logoutTimer = setTimeout(userLogOut, remainingTime);

    return { token, expiresAt, firstName, lastName };
  }
);

export const userLogOut = createAsyncThunk("auth/userLogOut", async () => {
  localStorage.removeItem("authTokenPIXELBAY");
  localStorage.removeItem("expiresAtPIXELBAY");
  localStorage.removeItem("firstNamePIXELBAY");
  localStorage.removeItem("lastNamePIXELBAY");

  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }
});
